import { $, insertHTML, setAttributes } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import Shower from 'modules/shower';
import AniScroll from 'modules/ani-scroll';

const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  success: {
    de: '<p><strong><span>Vielen Dank für Ihren Kommentar! Wir werden ihn vor der Veröffentlichung prüfen. Danke für Ihre Geduld.</span></strong></p>',
    en: '<p><strong><span>Your comment has to be checked before publishing. Thank you for your patience!</span></strong></p>',
  },
};

class Comments {
  constructor(props) {
    this.container = props.container;
    this.ajaxContainer = $('.comments__inner', this.container);
    this.commentCountContainer = $('.comments__count', this.container);
    this.formUrl = this.container.dataset.new;
    this.commentsUrl = this.container.dataset.list;
    this.axios = null;
  }

  ajaxCall = (ajaxUrl, isForm) => {
    this.axios
      .get(ajaxUrl)
      .then(({ data }) => {
        // Parse response string to html.
        const $response = new DOMParser().parseFromString(data, 'text/html')
          .body.firstChild;

        this.handleConfigResponse($response, isForm);
      })
      .catch(error => {
        console.error(error);
      });
  };

  handleConfigResponse = ($response, isForm) => {
    this.insertHTML($response);

    if (isForm) {
      // if form is loaded: initialize the form accordion and trigger another ajax call to get the list of comments
      this.initAccordion();
      this.bindSubmit();
      this.ajaxCall(this.commentsUrl, false);
    } else {
      // if comments list is loaded: get the comment-count data-attribute attached to the list and update the amount of comments in the section heading
      this.setCommentCount();
    }
  };

  insertHTML = $response => {
    insertHTML(this.ajaxContainer, 'beforeend', $response.outerHTML);
  };

  initAccordion = initOpened => {
    const accordion = $('.comments__add-comment');

    if (accordion) {
      const randomID = uniqueId();
      const target = $('.comments__form', accordion);
      const handler = $('.comments__toggle', accordion);

      setAttributes(handler, {
        id: `acc-btn-${randomID}`,
        'aria-controls': `acc-tab-${randomID}`,
      });

      setAttributes(target, {
        id: `acc-tab-${randomID}`,
        'aria-labelledby': `acc-btn-${randomID}`,
      });

      this.commentAccordion = new Shower({
        target,
        handler,
        easing: 'easeInOutQuart',
        duration: 400,
        initOpened,
        openClassName: 'is-active',
      });
      this.commentAccordion.init();
    }
  };

  setCommentCount = () => {
    const commentCount = $('.comments__list').dataset.commentCount;
    insertHTML(this.commentCountContainer, 'beforeend', `(${commentCount})`);
  };

  submitForm = async () => {
    this.submitButton.disabled = true;

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const formData = new FormData(this.form);
    let response;

    // cant use post request in local env, so we use get instead while developing
    if (process.env.NODE_ENV !== 'production') {
      response = await this.axios.get(this.postUrl);
    } else {
      response = await this.axios.post(this.postUrl, formData, config);
    }

    const hasError = response.data.indexOf('form__error') > -1;
    const header = $('.header');

    if (hasError) {
      // on error:
      // 1) replace html of form and accordion button with response that contains typo3 generated error messages
      // 2) re-init new accordion and bind submit event
      // 3) scroll to error message when accordion is open
      $('.comments__add-comment').innerHTML = response.data;
      this.initAccordion(true);
      this.bindSubmit();
      setTimeout(() => {
        const scrollToPosition = header
          ? this.formMessage.offsetTop - header.offsetHeight
          : this.formMessage.offsetTop;
        AniScroll(scrollToPosition, 500, 'easeOutQuad');
      }, 500);
    } else {
      // on success
      // 1) show success message
      // 2) close accordion
      // 3) disable submit button
      // 4) scroll to success message
      this.successMessage.innerHTML = labels.success[lang];
      this.commentAccordion.close();
      this.submitButton.disabled = false;

      setTimeout(() => {
        const scrollToPosition = header
          ? this.successMessage.offsetTop - header.offsetHeight
          : this.successMessage.offsetTop;
        AniScroll(scrollToPosition, 500, 'easeOutQuad');
      }, 500);
    }
  };

  bindSubmit = () => {
    this.form = $('form', this.container);
    this.submitButton = $('.btn--submit', this.form);
    this.postUrl = this.form.getAttribute('action');
    this.successMessage = $('.comments__success', this.container);
    this.formMessage = $('.form__message', this.container);
    this.submitButton.addEventListener('click', this.submitForm);
  };

  bindEvents = () => {
    window.addEventListener('load', () => this.ajaxCall(this.formUrl, true));
  };

  init = () => {
    import(/* webpackChunkName: 'axios' */ 'axios').then(_ => {
      this.axios = _.default;

      if (this.formUrl) {
        this.bindEvents();
      } else {
        this.initAccordion(false);
      }
    });
  };
}

const comments = $('.comments');
comments &&
  new Comments({
    container: comments,
  }).init();
